import { IAddress } from '@numeo/types-core'
import { FormControl, FormLabel, Input, Stack } from '@mui/joy'
import React from 'react'

interface AddressFieldGroupProps {
    address: IAddress
    onChange: (address: IAddress) => void
    disabled?: boolean
}

export const AddressFieldGroup: React.FC<AddressFieldGroupProps> = ({ address, onChange, disabled = false }) => {
    const handleChange = (field: keyof IAddress, value: string | null) => {
        onChange({
            ...address,
            [field]: value || null,
        })
    }

    return (
        <FormControl>
            <FormLabel>Address</FormLabel>
            <Stack spacing={1.5}>
                <Input
                    placeholder="Street"
                    value={address.street || ''}
                    onChange={(e) => handleChange('street', e.target.value)}
                    disabled={disabled}
                    size="sm"
                />
                <Stack direction="row" spacing={1}>
                    <Input
                        placeholder="City"
                        value={address.city || ''}
                        onChange={(e) => handleChange('city', e.target.value)}
                        disabled={disabled}
                        size="sm"
                        sx={{ flex: 2 }}
                    />
                    <Input
                        placeholder="State"
                        value={address.state || ''}
                        onChange={(e) => handleChange('state', e.target.value)}
                        disabled={disabled}
                        size="sm"
                        sx={{ flex: 1 }}
                    />
                </Stack>
                <Stack direction="row" spacing={1}>
                    <Input
                        placeholder="ZIP Code"
                        value={address.zip || ''}
                        onChange={(e) => handleChange('zip', e.target.value)}
                        disabled={disabled}
                        size="sm"
                        sx={{ flex: 1 }}
                    />
                    <Input
                        placeholder="Country"
                        value={address.country || ''}
                        onChange={(e) => handleChange('country', e.target.value)}
                        disabled={disabled}
                        size="sm"
                        sx={{ flex: 1 }}
                    />
                </Stack>
            </Stack>
        </FormControl>
    )
}
